import {
  FAG_GROUP_STATUS_COLORS,
  FAG_GROUP_STATUS_LABELS,
} from "entities/faqs/constants";
import { FaqGroup, FaqGroupStatus } from "entities/faqs/types";
import React from "react";
import { Link } from "react-router-dom";
import Chip from "shared/components/Chip";
import { Column } from "shared/components/DragNDropTable/helpers";
import DropdownList, {
  DropdownListItemProps,
} from "shared/components/DropdownList";
import FlexCenter from "shared/components/Layout/components/FlexCenter";
import { COLOR_BLACK, COLOR_PRIMARY_MAIN } from "shared/theme/colors";
import { ArrowForwardIcon } from "shared/theme/icons/ArrowForwardIcon";
import { StyledActionsWrapper } from "./styled";
import { FaqGroupsColumnsProps } from "./types";

const renderGroupTitle = (item: FaqGroup) => {
  return (
    <FlexCenter columnGap="0.75rem">
      <Link to={item.id} style={{ color: COLOR_BLACK }}>
        {item.title}
      </Link>
    </FlexCenter>
  );
};

export const getPagesColumns = ({
  handlePublishStatus,
  handleOpenDeleteModal,
  faqGroupDrawer,
  readOnly,
}: FaqGroupsColumnsProps): Column<FaqGroup>[] => {
  const renderActions = (faqGroup: FaqGroup) => {
    const { status, id: pageId } = faqGroup;

    if (readOnly) {
      return (
        <StyledActionsWrapper onClick={() => faqGroupDrawer.openDrawer(pageId)}>
          <ArrowForwardIcon color={COLOR_PRIMARY_MAIN} />
        </StyledActionsWrapper>
      );
    }

    const statusTitle =
      status === FaqGroupStatus.Active ? "Unpublish" : "Publish";

    const items = [
      {
        title: "Edit",
        onClick: () => faqGroupDrawer.openDrawer(pageId),
      },
      {
        title: statusTitle,
        onClick: () => {
          handlePublishStatus({
            ...faqGroup,
            status:
              status === FaqGroupStatus.Active
                ? FaqGroupStatus.Draft
                : FaqGroupStatus.Active,
          });
        },
      },
      {
        title: "Delete",
        style: "remove",
        onClick: () => handleOpenDeleteModal(faqGroup),
      },
    ].filter((item) => item !== null) as DropdownListItemProps[];

    return <DropdownList items={items} />;
  };

  return [
    {
      headerName: "Groups",
      align: "left",
      headerAlign: "left",
      width: "43%",
      renderCell: (item: FaqGroup) => renderGroupTitle(item),
    },
    {
      headerName: "Questions",
      width: "30%",
      align: "left",
      headerAlign: "left",
      renderCell: (item: FaqGroup) => item.questionsCount,
    },
    {
      headerName: "Status",
      width: "25%",
      align: "left",
      headerAlign: "left",
      renderCell: (item) => {
        const status = item.status as FaqGroupStatus;
        return (
          <Chip
            title={FAG_GROUP_STATUS_LABELS[status]}
            bgColor={FAG_GROUP_STATUS_COLORS[status]}
          />
        );
      },
    },

    {
      headerName: "",
      width: "11.25%",
      align: "right",
      headerAlign: "right",
      renderCell: (item: FaqGroup) => {
        return renderActions(item);
      },
    },
  ];
};
